<template>
  <div>
    <c-table
      ref="table"
      title="시나리오 목록"
      :columns="grid.columns"
      :gridHeight="setheight"
      :data="process.scenarios"
      :merge="grid.merge"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable&&!disabled"
      selection="multiple"
      rowKey="ramKrasAssessScenarioId"
      @callbackProxy="callbackProxy"
      @innerBtnClicked="innerBtnClicked"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn 
            v-show="editable&&!disabled" 
            :isSubmit="isComplete"
            :url="completeUrl"
            :param="process"
            mappingType="PUT"
            :label="'공정[' + process.processName + '] 평가완료'" 
            icon="check"
            @beforeAction="completeProcess"
            @btnCallback="completeProcessCallback" />
          <c-btn 
            v-if="editable&&!disabled" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="process.scenarios"
            mappingType="PUT"
            label="저장" 
            icon="save"
            @beforeAction="saveScenario"
            @btnCallback="saveScenarioCallback" />
          <c-btn v-if="editable&&!disabled" label="삭제" icon="remove" @btnClicked="removeScenario" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
          <q-chip
            v-for="(item, index) in chipDatas(props.row['sopImprovementIds'], props.row['ibmStepNames'])"
            :key="index"
            :color="item.color"
            :clickable="true"
            text-color="white"
            style="margin-bottom:4px !important;"
            @click="linkClick(item, props.row)">
            {{item.title}}
          </q-chip>
        </template>
        <template v-else>
        </template>
        <div v-if="editable && Boolean(props.row.ramKrasAssessScenarioId) && props.row.editFlag !== 'C' && !disabled">
          <q-btn-group outline class="ColumInnerBtnGroup">
            <q-btn
              icon="add"
              color="red-6"
              text-color="white"
              class="ColumInnerBtn"
              align="center"
              @click.prevent="innerBtnClicked(col, props)">
              <q-tooltip>
                개선요청등록
              </q-tooltip>
            </q-btn>
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'kras-scenario',
  props: {
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        assessUserName: '',  // 평가 담당자
        ramMatrixId: '',
        scenarios: [],
      }),
    },
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'riskHazardNameClass' },
        ],
        columns: [
          {
            name: 'riskHazardNameClass',
            field: 'riskHazardNameClass',
            label: '분류-유해위험요인',
            align: 'left',
            style: 'width:250px',
            sortable: false,
            innerBtn: true,
            btns: [
              { label: '', icon: 'add', color: 'light-blue', value: '1', tooltip: '가능한 원인 추가 <font color="#F0F4C3"><b>(※ 관리되는 항목)</b></font>' },
              { label: '', icon: 'add', color: 'orange', value: '2', tooltip: '원인 추가' },
            ],
          },
          {
            name: 'relationLaw',
            field: 'relationLaw',
            label: '관련법규',
            align: 'left',
            type: 'text',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'riskOccurrenceCause',
            field: 'riskOccurrenceCause',
            label: '원인',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'riskOccurrenceResult',
            field: 'riskOccurrenceResult',
            label: '결과',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: false,
            required: true,
          },
          {
            name: 'currentSafetyMeasures',
            field: 'currentSafetyMeasures',
            label: '현재안전조치',
            align: 'left',
            type: 'text',
            style: 'width:150px',
            sortable: false,
            required: true,
          },
          {
            name: 'before',
            field: 'before',
            label: '개선전',
            align: 'center',
            child: [
              {
                name: 'beforeFrequency',
                field: 'beforeFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'beforeStrength',
                field: 'beforeStrength',
                label: '강도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'beforeRisk',
                field: 'beforeRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                required: true,
                type: 'proxy',
                component: () => import(`${'@/pages/ram/base/matrixPop.vue'}`)
              },
            ]
          },
          {
            name: 'after',
            field: 'after',
            label: '개선후',
            align: 'center',
            child: [
              {
                name: 'afterFrequency',
                field: 'afterFrequency',
                label: '빈도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'afterStrength',
                field: 'afterStrength',
                label: '강도',
                align: 'center',
                style: 'width:50px',
                sortable: false
              },
              {
                name: 'afterRisk',
                field: 'afterRisk',
                label: '위험도',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                required: true,
                type: 'proxy',
                component: () => import(`${'@/pages/ram/base/matrixPop.vue'}`)
              },
            ]
          },
          {
            name: 'assessDate',
            field: 'assessDate',
            label: '평가일',
            align: 'center',
            type: 'date',
            style: 'width:100px',
            sortable: false,
            required: true,
          },
          {
            name: 'assessUserName',
            field: 'assessUserName',
            label: '평가자',
            align: 'center',
            type: 'user',
            userId: 'assessUserId',
            style: 'width:100px',
            sortable: false,
            required: true,
          },
          {
            name: 'riskbookFlag',
            field: 'riskbookFlag',
            label: '위험등록부',
            align: 'center',
            sortable: true,
            type: 'check',
            'true': 'Y',
            'false': 'N',
            disableTarget: 'riskRegisterFlag',
            disableCon: false
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:150px',
                type: 'custom',
                sortable: false
              },
              {
                name: 'improvementMeasures',
                field: 'improvementMeasures',
                label: '개선대책',
                align: 'left',
                style: 'width:150px',
                type: 'text',
                sortable: false
              },
            ]
          },
        ],
        data: [],
        height: '600px'
      },
      colorItems: [],
      requestImprRow: null,
      imprData: null,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
      rowIndex: 0,
      editable: true,
      isSave: false,
      isComplete: false,
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      completeUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return !(this.param.ramStepCd === 'RKRS00005' || this.param.ramStepCd == 'RKRS00010') || this.process.ramProcessAssessStepCd === 'RPA0000005'
    },
    setheight() {
      let pxRemove = this.height.replace('px', '');
      return this.height && this.height.indexOf('px') > -1 && !isNaN(pxRemove) ? (Number(pxRemove) - 50) + 'px' : '500px'
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.kras.scenario.list.url
      this.saveUrl = transactionConfig.ram.kras.scenario.save.url
      this.deleteUrl = transactionConfig.ram.kras.scenario.delete.url
      this.completeUrl = transactionConfig.ram.assessProcess.complete.url;
      // code setting
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });
      // list setting
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,
        processCd: this.process.processCd,
      }
      this.$http.request((_result) => {
        this.process.scenarios = _result.data;
      },);
    },
    research() {
      this.$emit('research', 'scenario')
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      if (col.name === 'riskHazardNameClass') {
        if (btn.value === '1') {
          this.rowIndex = props.rowIndex;
          this.popupOptions.title = '유해위험요인별 원인/결과'; // 유해위험요인별 원인/결과
          this.popupOptions.param = {
            type: 'multiple',
            searchType: '6', //1: 작업조회, 2:작업단계, 3:작업단계별 유해위험요인, 4:작업단계별 유해위험요인별 원인/결과
            subProcessCd: this.process.processCd,
            mdmHazardFactorsId: props.row.ramRiskHazardId,
          };
          this.popupOptions.target = () => import(`${'@/pages/common/process/sopPop.vue'}`);
          this.popupOptions.width = '70%';
          this.popupOptions.visible = true;
          this.popupOptions.closeCallback = this.closeCausePopup;
        } else {
          this.process.scenarios.splice(props.rowIndex, 0, {
            ramKrasAssessScenarioId: uid(),  // 시나리오 일련번호_시나리오의 한 라인(원일별)
            ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,  // 평가 일련번호
            processCd: this.process.processCd,  // 단위공정 코드
            ramRiskHazardClassCd: props.row.ramRiskHazardClassCd,  // 유해위험분류 코드
            ramRiskHazardId:props.row.ramRiskHazardId,  // 유해위험요인 코드
            riskHazardName: props.row.riskHazardName,  // 유해위험요인 명
            riskHazardNameClass: props.row.riskHazardNameClass,  // 유해위험요인 명
            riskOccurrenceCause: '',  // 위험발생 원인
            riskOccurrenceResult: '',  // 위험발생 결과
            relationLaw: '',  // 관련법규_유해위험요인 마스터에스 불러와서 편집후 저장
            currentSafetyMeasures: '',  // 현재 안전조치
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            improvementMeasures: '',  // 개선대책
            assessDate: this.$comm.getToday(),  // 평가일
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            sopImprovementIds: '', 
            ibmStepNames: '', 
            riskbookFlag: 'N', 
            editFlag: 'C',
            ramMatrixId: this.process.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            riskRegisterFlag: false,
          });
        }
      } else if (col.name === 'customCol') {
        this.requestImprRow = props.row
        let requestContents = props.row.riskHazardNameClass;
        if (props.row.riskOccurrenceCause) {
          requestContents += ' / ' + props.row.riskOccurrenceCause
        }
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.ramKrasAssessScenarioId,
          ibmTaskTypeCd: 'ITT0000020',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeCausePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          this.process.scenarios.splice(this.rowIndex, 0, {
            ramKrasAssessScenarioId: uid(),  // 시나리오 일련번호_시나리오의 한 라인(원일별)
            ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,  // 평가 일련번호
            processCd: this.process.processCd,  // 단위공정 코드
            ramRiskHazardClassCd: item.ramRiskHazardClassCd,  // 유해위험분류 코드
            ramRiskHazardId:item.mdmHazardFactorsId,  // 유해위험요인 코드
            riskHazardName: item.riskHazardName,  // 유해위험요인 명
            riskHazardNameClass: item.riskHazardNameClass,  // 유해위험요인 명
            riskOccurrenceCause: item.hazardOccurReason,  // 위험발생 원인
            riskOccurrenceResult: item.hazardOccurResult,  // 위험발생 결과
            relationLaw: item.relevantLegalStandards,  // 관련법규_유해위험요인 마스터에스 불러와서 편집후 저장
            currentSafetyMeasures: '',  // 현재 안전조치
            beforeRamMatrixRiskId: '',  // 전 위험도 no
            afterRamMatrixRiskId: '',  // 후 위험도 no
            improvementMeasures: '',  // 개선대책
            assessDate: this.$comm.getToday(),  // 평가일
            assessUserName: this.$_.clone(this.process.assessUserName),
            assessUserId: this.$_.clone(this.process.assessUserId),
            sopImprovementIds: '', 
            ibmStepNames: '', 
            riskbookFlag: 'N', 
            editFlag: 'C',
            ramMatrixId: this.process.ramMatrixId,
            // 위험등록부 등재를 위한 prop
            riskRegisterFlag: false,
          });
        });
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
          if (sData.indexOf(item.sopImprovementId) === -1) {
            this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
              this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
            this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
              this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
          }
        })
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.research();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;
      this.popupOptions.title = '개선';
      this.popupOptions.param = {
        sopImprovementId: data.sopImprovementId,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '90%';
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        if (result.col1.ibmStepCd === 'IS00000010' || result.col1.ibmStepCd === 'IS00000015' || result.col1.ibmStepCd === 'IS00000020') {
          this.requestImprRow.riskRegisterFlag = true
        }
        let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
        let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
        if (splitId && splitId.length > 0) {
          let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
          splitStep[idIndex] = result.col1.ibmStepName;
          this.requestImprRow.ibmStepNames = splitStep.toString();
        }
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.research();
      }
    },
    /* eslint-disable no-unused-vars */
    callbackProxy(data, props, col) {
      if (col.name === 'beforeRisk') {
        this.$set(this.process.scenarios[props.rowIndex], 'beforeFrequency', data.f)
        this.$set(this.process.scenarios[props.rowIndex], 'beforeStrength', data.s)
        this.$set(this.process.scenarios[props.rowIndex], 'beforeRisk', data.r)
        this.$set(this.process.scenarios[props.rowIndex], 'beforeRamMatrixRiskId', data.ramMatrixRiskId)
      } else {
        this.$set(this.process.scenarios[props.rowIndex], 'afterFrequency', data.f)
        this.$set(this.process.scenarios[props.rowIndex], 'afterStrength', data.s)
        this.$set(this.process.scenarios[props.rowIndex], 'afterRisk', data.r)
        this.$set(this.process.scenarios[props.rowIndex], 'afterRamMatrixRiskId', data.ramMatrixRiskId)
      }
      if (this.process.scenarios[props.rowIndex].editFlag !== 'C') {
        this.$set(this.process.scenarios[props.rowIndex], 'editFlag', 'U')
      }
    },
    chipDatas(sopImprovementIds, ibmStepNames) {
      let returnData = [];
      let splitId = this.$_.split(sopImprovementIds, ',');
      let splitStep = this.$_.split(ibmStepNames, ',');

      if (splitId.length === splitStep.length) {
        let i = 0;
        this.$_.forEach(splitId, item => {
          let color = this.$_.find(this.colorItems, { stepperMstNm: splitStep[i] });
          returnData.push({
            title: item + ' / ' + splitStep[i],
            color: color ? color.colorClass : '',
            sopImprovementId: item,
          });
          i++;
        });
      }
      return returnData;
    },
    saveScenario() {
      if (this.$comm.validTable(this.grid.columns, this.process.scenarios)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(this.process.scenarios, item => {
              item.regUserId = this.$store.getters.user.userId
              item.chgUserId = this.$store.getters.user.userId
            })
            
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveScenarioCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.research();
      this.getList();
    },
    removeScenario() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.process.scenarios.splice(this.$_.findIndex(this.process.scenarios, item), 1)
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    completeProcess() {
      // 도면 별 노드에 시나리오가 하나 이상 등록되었는지?
      // 화면에서 추가는 하고 저장을 하지 않았을 시에 해당 데이터도 일괄 저장 처리
      // 저장 처리 후 callback에서 process 목록 재조회
      let isProgress = true;
      if (!this.process.scenarios || this.process.scenarios.length === 0) {
        isProgress = false
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '공정 [' + this.process.processName + ']에 등록된 시나리오가 없습니다.',
          type: 'warning', // success / info / warning / error
        });
      }

      if (isProgress) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '완료하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.process.chgUserId = this.$store.getters.user.userId
            this.process.ramProcessAssessStepCd = 'RPA0000005';

            this.isComplete = !this.isComplete
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    completeProcessCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('assessComplete', _result.data)
    },
  }
};
</script>
<style lang="sass">
.scenario-chip i 
  margin-right: -0.2em !important
</style>
